interface TempoIconProps {
  className?: string
}

export function TempoIcon({ className }: TempoIconProps) {
  // viewBox tightened around the glyph (bbox ~195x200 centered at 960,540) with ~20% padding,
  // so the mark fills the icon rather than floating in a 1920x1080 canvas.
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" className={className}>
      <circle cx="100" cy="100" r="100" fill="white" />
      <path d="M95.16,145h-24.60l22.80,-69.60h-29.16l6.36,-20.40h81.24l-6.36,20.40h-27.60l-22.68,69.60Z" />
    </svg>
  )
}
